import { del, get, post, put } from "../../helpers/utils/http-client";
import { APPS_ENDPOINT } from "../../consts/api-endpoints";

export async function getSchedulers(appId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/schedulers`);
        if (status !== 200) {
            return []
        }
        return response.data;
    } catch (err) {
        console.debug('getSchedulers cause', err.message, err.code);
        return [];
    }
}

export async function getScheduler(appId, schedulerId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/schedulers/${schedulerId}`);
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('getScheduler cause', err.message, err.code);
        return null;
    }
}

export async function createScheduler(appId, schedulerData) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/schedulers`, schedulerData);
    } catch (err) {
        console.debug('createScheduler cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function updateScheduler(appId, schedulerId, schedulerData) {
    try {
        return await put(`${APPS_ENDPOINT}/${appId}/schedulers/${schedulerId}`, schedulerData);
    } catch (err) {
        console.debug('updateScheduler cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function deleteScheduler(appId, schedulerId) {
    try {
        return await del(`${APPS_ENDPOINT}/${appId}/schedulers/${schedulerId}`);
    } catch (err) {
        console.debug('deleteScheduler cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}
